const defaultStorage = () => ({
  name: '',
  maxSize: 0,
  expireDays: 0,
  priority: 0,
});

export default defaultStorage;
